import ReduxHelper from 'lib/ReduxHelper';
import { REPORTS_ACTION_TYPES as AT } from './Reports.actions';

export const defaultState = {
  error: null,

  fetchingAuctionsPerInsurance: false,
  auctionsPerInsurance: null,

  fetchingAuctionsPerMerchant: false,
  auctionsPerMerchant: null,

  fetchingAuctionsPerExpert: false,
  auctionsPerExpert: null,

  fetchingReportGeneralData: false,
  reportGeneralData: null,
  reportGeneralDataError: null,

  fetchingReportFolderData: false,
  reportFolderData: null,
  reportFolderDataError: null,
};

const reportsReducer = (state = defaultState, action) => {
  switch (action.type) {
    case AT.REPORTS_FETCH_AUCTION_DATA:
      let fetchingObj = {};
      if (action.group === 'insurances' || action.group === 'all')
        fetchingObj.fetchingAuctionsPerInsurance = true;
      if (action.group === 'merchants' || action.group === 'all')
        fetchingObj.fetchingAuctionsPerMerchant = true;
      if (action.group === 'experts' || action.group === 'all')
        fetchingObj.fetchingAuctionsPerExpert = true;
      return Object.assign({}, state, fetchingObj);

    case AT.REPORTS_FETCH_AUCTION_DATA_SUCCESS:
      let newStatus = {};
      if (!!action.payload.Report.AuctionsPerInsurance) {
        newStatus.fetchingAuctionsPerInsurance = false;
        newStatus.auctionsPerInsurance =
          action.payload.Report.AuctionsPerInsurance;
      }
      if (!!action.payload.Report.AuctionsPerMerchant) {
        newStatus.fetchingAuctionsPerMerchant = false;
        newStatus.auctionsPerMerchant =
          action.payload.Report.AuctionsPerMerchant;
      }
      if (!!action.payload.Report.AuctionsPerExpert) {
        newStatus.fetchingAuctionsPerExpert = false;
        newStatus.auctionsPerExpert = action.payload.Report.AuctionsPerExpert;
      }
      return Object.assign({}, state, newStatus, { error: null });
    case AT.REPORTS_FETCH_AUCTION_DATA_FAIL:
      return Object.assign({}, state, {
        fetchingReportData: false,
        reportData: null,
        error: ReduxHelper.extractError(action),
      });
    case AT.REPORTS_CLEAR_DATA:
      return Object.assign({}, state, {
        fetchingReportData: false,
        reportData: null,
        error: null,
      });

    case AT.REPORTS_FETCH_ADMIN_GENERAL_DATA:
    case AT.REPORTS_FETCH_MERCHANT_GENERAL_DATA:
    case AT.REPORTS_FETCH_INSURANCE_GENERAL_DATA:
      return Object.assign({}, state, {
        fetchingReportGeneralData: true,
        reportGeneralDataError: null,
      });
    case AT.REPORTS_FETCH_ADMIN_GENERAL_DATA_SUCCESS:
    case AT.REPORTS_FETCH_MERCHANT_GENERAL_DATA_SUCCESS:
    case AT.REPORTS_FETCH_INSURANCE_GENERAL_DATA_SUCCESS:
      return Object.assign({}, state, {
        fetchingReportGeneralData: false,
        reportGeneralData: Object.assign({}, action.payload),
      });
    case AT.REPORTS_FETCH_ADMIN_GENERAL_DATA_FAIL:
    case AT.REPORTS_FETCH_MERCHANT_GENERAL_DATA_FAIL:
    case AT.REPORTS_FETCH_INSURANCE_GENERAL_DATA_FAIL:
      return Object.assign({}, state, {
        fetchingReportGeneralData: false,
        reportGeneralData: null,
        reportGeneralDataError: action.error,
      });

    case AT.REPORTS_FETCH_ADMIN_FOLDER_DATA:
    case AT.REPORTS_FETCH_INSURANCE_FOLDER_DATA:
      return Object.assign({}, state, {
        fetchingReportFolderData: true,
        reportFolderDataError: null,
      });
    case AT.REPORTS_FETCH_ADMIN_FOLDER_DATA_SUCCESS:
    case AT.REPORTS_FETCH_INSURANCE_FOLDER_DATA_SUCCESS:
      return Object.assign({}, state, {
        fetchingReportFolderData: false,
        reportFolderData: Object.assign({}, action.payload),
      });
    case AT.REPORTS_FETCH_ADMIN_FOLDER_DATA_FAIL:
    case AT.REPORTS_FETCH_INSURANCE_FOLDER_DATA_FAIL:
      return Object.assign({}, state, {
        fetchingReportFolderData: false,
        reportFolderData: null,
        reportFolderDataError: action.error,
      });

    default:
      return state;
  }
};

export default reportsReducer;
